import axios from 'axios';
import addDays from 'date-fns/addDays';

export const getTemplates = async (providerId) => {
	const { data } = await axios.get(
		`/providers/${providerId}/appointment_template`
	);
	return data;
};

export const applyTemplate = (
	providerId,
	templateId,
	weekStartDate,
	appointmentDuration
) =>
	axios.post(`/providers/${providerId}/apply-scheduling-template`, {
		templateId,
		weekStartDate,
		appointmentDuration,
	});

export const viewSchedule = async (
	providerId,
	dateStart = new Date(),
	dateEnd = addDays(new Date(), 30)
) => {
	// const { data } = await axios.get(`/providers/${providerId}/view-schedule`, { params: { dateStart, dateEnd }});
	const { data } = await axios.get(
		`/providers/${providerId}/view-practice-schedule`,
		{ params: { dateStart, dateEnd } }
	);
	if (data && data.status) {
		return data.status;
	}
	return [];
};

export const createAppointmentSlot = async (
	providerId,
	startDateTime,
	endDateTime
) =>
	await axios.post(`/providers/${providerId}/create-appointment-slot`, {
		startDateTime,
		endDateTime,
	});

export const deleteAppointmentSlot = async (providerId, appointmentId) =>
	await axios.post(`/providers/${providerId}/cancel-appointment`, {
		appointmentId,
		keepSlotAvailable: false,
	});

export const getPracticeProviders = async (practiceId) => {
	const { data } = await axios.get(
		`/provider_practices/${practiceId}/list-providersV2`
	);
	if (data && data.providersList) {
		return data.providersList;
	}
	return [];
};

export const getEvisitDetails = async (evisitId) => {
	const { data } = await axios.get(`/evisits/${evisitId}`, {
		params: {
			filter: JSON.stringify({
				include: [
					'patient',
					'patient_dependent',
					'provider_visit_type',
					'provider',
					{
						relation: 'evisit_provider_transactions',
						scope: {
							limit: 1,
							order: 'update_dttm DESC',
							include: 'provider',
						},
					},
				],
			}),
		},
	});
	return data;
};

export const updateScheduleNote = async ({
	providerId,
	notes,
	appointmentId,
}) =>
	await axios.post(`/providers/${providerId}/update-schedule-note`, {
		notes,
		appointmentId,
	});

export const getReasonsForVisit = async (userId, providerId) => {
	const { data } = await axios.get(
		`/providers/${userId}/provider-visit-type-lookup`,
		{ params: { providerId } }
	);
	let preparedData = [];
	if (data && data.status) {
		preparedData = data.status.map((visitType) => ({
			...visitType,
			label: visitType.visit_type,
			value: visitType.provider_visit_type_id,
		}));
	}
	return preparedData;
};

export const getPracticePatients = async (
	providerId,
	provider_practice_virtual_id
) => {
	let params;
	if (provider_practice_virtual_id) {
		params = { provider_practice_virtual_id };
	}
	const { data } = await axios.get(`/providers/${providerId}/practice-panel`, {
		params,
	});
	return data.status;
};

export const createVisitAndScheduleAppointment = async (providerId, evisit) => {
	const { data } = await axios.post(
		`/providers/${providerId}/schedule-patient`,
		evisit
	);
	return data.status;
};

export const generatePatientCode = async (
	providerId,
	{ firstName, lastName, birthDate, providerCode, appointmentId, visitReason }
) => {
	const appointmentData = {
		name_first: firstName,
		name_last: lastName,
		birth_dt: birthDate,
		providerCode,
		appointmentId,
		provider_visit_type_id: parseInt(visitReason, 10),
	};
	const { data } = await axios.post(
		`/providers/${providerId}/generate-patient-pre-registration`,
		appointmentData
	);
	return data.status;
};

export const getPreRegPatient = async (providerId, appointmentId) => {
	const { data } = await axios.get(
		`/providers/${providerId}/get-pre-reg-appointments`,
		{ params: { appointmentId } }
	);
	return data.status;
};

export const getLinkedVirtualPractices = (providerId) =>
	axios.get(`/providers/${providerId}/view-linked-virtual-practices`);
